import script from "./Deletion_Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Deletion_Policy.vue?vue&type=script&setup=true&lang=js"

import "./Deletion_Policy.vue?vue&type=style&index=0&id=cb63f3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb63f3ba"]])

export default __exports__